import toastr from 'toastr';

toastr.options = {
  closeButton: false,
  debug: false,
  newestOnTop: false,
  progressBar: false,
  positionClass: 'toast-top-full-width',
  preventDuplicates: false,
  onclick: null,
  showDuration: '300',
  hideDuration: '1000',
  timeOut: '8000',
  showEasing: 'swing',
  hideEasing: 'linear',
  showMethod: 'fadeIn',
  hideMethod: 'fadeOut',
};

export default {
  success (message, title) {
    toastr.success(message, title || '');
  },
  error (message, title) {
    toastr.error(message, title || '');
  },
  warning (message, title) {
    toastr.warning(message, title || '');
  },
  info (message, title) {
    toastr.info(message, title || '');
  },
};
